import { useTranslation } from 'react-i18next';

export interface NewBackButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'children'> {
  onBack: () => void;
}

/**
 * NewBackButton — master-design `.bombiix-btn.btn-light` back button
 * (BM-9522 family). Content-sized, no forced min-width, so it never needs the
 * `justify-content` workaround the old shared `BtnBack`/`.btn-back-lib`
 * required. Use everywhere a PIM toolbar needs a "Back" action instead of
 * `Components/Utility/FilterAction/BtnBack`.
 */
function NewBackButton({ onBack, className, ...rest }: NewBackButtonProps) {
  const { t } = useTranslation('common');
  const rootClass = ['bombiix-btn', 'btn-light', className].filter(Boolean).join(' ');
  return (
    <button type="button" className={rootClass} onClick={onBack} {...rest}>
      {t('APPROVE_REJECTS.BACK')}
    </button>
  );
}

export default NewBackButton;
